import { app } from '../app';

app.config(config);

/** @ngInject */
function config($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

/** @ngInject */
function interceptor($q, Alert) {
    const responseError = response => {
        const message = (response.data || {}).message;
        const showErrorAlert = !(response.config || {}).skipErrorAlert;
        if (message && showErrorAlert) {
            Alert('danger', message);
        }
        return $q.reject(response);
    };

    return {responseError};
}



// WEBPACK FOOTER //
// ./src/portal/config/error-interceptor.config.js